import { useEffect } from 'react';

import Loader from 'Shared/Components/Loader/Loader';
import { useUserManager } from 'Shared/User/Hooks/useUserManager';

const SignOutCallbackPage = () => {
  const { SignOutCallbackPage } = useUserManager();

  useEffect(() => {
    SignOutCallbackPage();
  }, []);

  return <Loader active={true} />;
};

export default SignOutCallbackPage;
